import { render, staticRenderFns } from "./add-educational-programs.vue?vue&type=template&id=6b7fdef9&scoped=true"
import script from "./add-educational-programs.vue?vue&type=script&lang=js"
export * from "./add-educational-programs.vue?vue&type=script&lang=js"
import style0 from "./add-educational-programs.vue?vue&type=style&index=0&id=6b7fdef9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b7fdef9",
  null
  
)

export default component.exports